// extracted by mini-css-extract-plugin
var _1 = "s8xsV";
export { _1 as "details" }
